(() => {
  if (document.documentElement.hasAttribute('data-whosify-v1-bound')) return;
  document.documentElement.setAttribute('data-whosify-v1-bound', 'true');
  let language = document.documentElement.lang.startsWith('zh') ? 'zh' : 'en';
  try { if (sessionStorage.getItem('whosify_home_language') === 'zh') language = 'zh'; } catch (_) {}
  const applyLanguage = () => {
    document.querySelectorAll('.whosify-v1 [data-w-lang]').forEach((el) => { el.hidden = el.dataset.wLang !== language; });
    document.querySelectorAll('.whosify-v1 [data-w-language]').forEach((el) => { el.dataset.wCurrent = language; el.setAttribute('aria-label', language === 'en' ? 'Switch to Traditional Chinese' : '切換至英文'); });
    document.documentElement.lang = language === 'zh' ? 'zh-Hant' : 'en';
  };
  const closeMenu = (restoreFocus = false) => {
    const button = document.querySelector('.whosify-v1 [data-w-menu-toggle]');
    const menu = document.getElementById('whosify-mobile-menu');
    if (button && menu) { button.setAttribute('aria-expanded', 'false'); menu.hidden = true; if (restoreFocus) button.focus(); }
  };
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('.whosify-v1 [data-w-language]')) {
      language = language === 'en' ? 'zh' : 'en';
      try { sessionStorage.setItem('whosify_home_language', language); } catch (_) {}
      applyLanguage();
    }
    const toggle = target.closest('.whosify-v1 [data-w-menu-toggle]');
    if (toggle) {
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (menu) { const isOpen = toggle.getAttribute('aria-expanded') === 'true'; toggle.setAttribute('aria-expanded', String(!isOpen)); menu.hidden = isOpen; }
    } else if (target.closest('#whosify-mobile-menu a') || !target.closest('[data-w-header]')) closeMenu();
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(true); });
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const carouselStates = new Map();
  const heroVideos = new Set();
  const initialiseVideo = (video) => {
    if (!heroVideos.has(video)) {
      video.dataset.wAutoplay = String(video.autoplay);
      heroVideos.add(video);
    }
    if (reducedMotion.matches) {
      video.autoplay = false;
      video.pause();
    } else if (video.dataset.wAutoplay === 'true') {
      video.autoplay = true;
      const playback = video.play();
      if (playback) playback.catch(() => {});
    }
  };
  const initialiseCarousel = (carousel) => {
    if (carouselStates.has(carousel)) return;
    const toggle = carousel.querySelector('[data-w-logo-toggle]');
    const rows = Array.from(carousel.querySelectorAll('[data-w-logo-viewport]')).map((viewport) => {
      const track = viewport.querySelector('[data-w-logo-track]');
      return track ? { viewport, track, items: Array.from(track.children), clone: null, distance: 0, position: 0,
        direction: viewport.dataset.wLogoDirection === 'right' ? -1 : 1 } : null;
    }).filter(Boolean);
    if (!rows.length || !toggle) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let frame = 0;
    let previousTime = 0;
    let hovered = false;
    let focused = false;
    let manualPaused = false;
    let editorPaused = false;
    let isReduced = reducedMotion.matches;
    const duration = Math.max(12, parseFloat(getComputedStyle(carousel).getPropertyValue('--w-logo-duration')) || 36) * 1000;
    const isStatic = () => isReduced;
    const isPaused = () => isStatic() || manualPaused || hovered || focused || editorPaused || document.hidden;
    const updateButton = () => {
      toggle.hidden = isStatic() || !rows.some((row) => row.clone);
      toggle.setAttribute('aria-pressed', String(manualPaused));
      const pauseLabel = toggle.querySelector('[data-w-pause]');
      const playLabel = toggle.querySelector('[data-w-play]');
      if (pauseLabel) pauseLabel.hidden = manualPaused;
      if (playLabel) playLabel.hidden = !manualPaused;
      carousel.dataset.wPaused = String(isPaused());
    };
    const stopFrame = () => {
      cancelAnimationFrame(frame);
      frame = 0;
      previousTime = 0;
    };
    const tick = (time) => {
      frame = 0;
      if (isPaused()) { previousTime = 0; return; }
      if (previousTime) {
        const elapsed = Math.min(time - previousTime, 64);
        rows.forEach((row) => {
          if (!row.clone || !row.distance) return;
          const nextPosition = row.position + row.direction * row.distance * elapsed / duration;
          row.position = (nextPosition % row.distance + row.distance) % row.distance;
          row.viewport.scrollLeft = row.position;
        });
      }
      previousTime = time;
      frame = requestAnimationFrame(tick);
    };
    const updateMotion = () => {
      updateButton();
      if (isPaused() || !rows.some((row) => row.clone && row.distance)) stopFrame();
      else if (!frame) {
        rows.forEach((row) => { row.position = row.viewport.scrollLeft; });
        frame = requestAnimationFrame(tick);
      }
    };
    const measure = () => {
      stopFrame();
      rows.forEach((row) => {
        const previousDistance = row.distance;
        const offset = row.viewport.scrollLeft;
        const style = getComputedStyle(carousel);
        const itemWidth = parseFloat(style.getPropertyValue('--w-logo-item-width')) || 160;
        const gap = parseFloat(style.getPropertyValue('--w-logo-gap')) || 36;
        const padding = parseFloat(style.getPropertyValue('--w-logo-track-padding')) || 6;
        const contentWidth = row.items.length * itemWidth + Math.max(0, row.items.length - 1) * gap + padding * 2;
        const trackWidth = Math.max(contentWidth, row.viewport.clientWidth);
        const widthValue = `${trackWidth}px`;
        [row.track, row.clone].filter(Boolean).forEach((track) => {
          if (track.style.getPropertyValue('--w-logo-track-width') !== widthValue) {
            track.style.setProperty('--w-logo-track-width', widthValue);
          }
        });
        row.distance = row.clone ? trackWidth + gap : 0;
        if (row.distance) {
          row.position = previousDistance ? offset / previousDistance * row.distance : row.direction < 0 ? row.distance : 0;
          row.viewport.scrollLeft = row.position;
        }
      });
      updateMotion();
    };
    const clearHover = () => {
      carousel.querySelectorAll('.w-logo-item.is-hovered').forEach((item) => item.classList.remove('is-hovered'));
    };
    const rebuild = () => {
      stopFrame();
      carousel.dataset.wReducedMotion = String(isReduced);
      carousel.dataset.wStatic = String(isStatic());
      rows.forEach((row) => {
        if (row.clone) row.clone.remove();
        row.clone = null;
        row.distance = 0;
        row.viewport.scrollLeft = 0;
        if (isStatic() || row.items.length < 2) return;
        row.clone = row.track.cloneNode(true);
        row.clone.removeAttribute('data-w-logo-track');
        row.clone.setAttribute('data-w-logo-clone', '');
        row.clone.setAttribute('aria-hidden', 'true');
        row.clone.inert = true;
        [row.clone, ...row.clone.querySelectorAll('*')].forEach((element) => {
          Array.from(element.attributes).forEach((attribute) => {
            if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
          });
          if (element.matches('a, button, input, select, textarea, [tabindex]')) element.setAttribute('tabindex', '-1');
        });
        row.viewport.append(row.clone);
      });
      measure();
    };
    carousel.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { hovered = true; updateMotion(); } }, options);
    carousel.addEventListener('pointerleave', (event) => { if (event.pointerType === 'mouse') { hovered = false; clearHover(); updateMotion(); } }, options);
    const hasLogoFocus = () => rows.some((row) => row.viewport.contains(document.activeElement));
    carousel.addEventListener('focusin', () => { focused = hasLogoFocus(); updateMotion(); }, options);
    carousel.addEventListener('focusout', () => {
      queueMicrotask(() => { focused = hasLogoFocus(); updateMotion(); });
    }, options);
    rows.forEach((row) => {
      row.viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.pointerType === 'pen') { manualPaused = true; updateMotion(); }
      }, options);
      row.viewport.addEventListener('pointermove', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearHover();
        const visibleItems = [...row.items, ...(row.clone ? Array.from(row.clone.children) : [])];
        const item = visibleItems.find((candidate) => {
          const bounds = candidate.getBoundingClientRect();
          return event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
        });
        if (item) item.classList.add('is-hovered');
      }, options);
    });
    toggle.addEventListener('click', () => { manualPaused = !manualPaused; updateMotion(); }, options);
    document.addEventListener('visibilitychange', updateMotion, options);
    const observer = new ResizeObserver(measure);
    rows.forEach((row) => { observer.observe(row.viewport); observer.observe(row.track); });
    const state = {
      setReducedMotion(value) { isReduced = value; rebuild(); },
      selectBlock(item) {
        editorPaused = true;
        updateMotion();
        const row = rows.find((candidate) => candidate.track.contains(item));
        if (row) row.viewport.scrollLeft = Math.max(0, item.offsetLeft - row.track.offsetLeft - (row.viewport.clientWidth - item.clientWidth) / 2);
      },
      deselectBlock() { editorPaused = false; updateMotion(); },
      destroy() { stopFrame(); controller.abort(); observer.disconnect(); rows.forEach((row) => { if (row.clone) row.clone.remove(); }); carouselStates.delete(carousel); }
    };
    carouselStates.set(carousel, state);
    rebuild();
  };
  const initialiseMotion = (root = document) => {
    carouselStates.forEach((state, carousel) => { if (!carousel.isConnected) state.destroy(); });
    heroVideos.forEach((video) => { if (!video.isConnected) heroVideos.delete(video); });
    root.querySelectorAll('[data-w-logo-carousel]').forEach(initialiseCarousel);
    root.querySelectorAll('[data-w-hero-video]').forEach(initialiseVideo);
  };
  reducedMotion.addEventListener('change', (event) => {
    carouselStates.forEach((state) => state.setReducedMotion(event.matches));
    heroVideos.forEach(initialiseVideo);
  });
  document.addEventListener('shopify:section:load', (event) => { applyLanguage(); initialiseMotion(event.target); });
  document.addEventListener('shopify:section:unload', (event) => {
    carouselStates.forEach((state, carousel) => { if (event.target.contains(carousel)) state.destroy(); });
    heroVideos.forEach((video) => { if (event.target.contains(video)) heroVideos.delete(video); });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target instanceof Element ? event.target.closest('.w-logo-item') : null;
    const carousel = item && item.closest('[data-w-logo-carousel]');
    const state = carousel && carouselStates.get(carousel);
    if (state) state.selectBlock(item);
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const carousel = event.target instanceof Element ? event.target.closest('[data-w-logo-carousel]') : null;
    const state = carousel && carouselStates.get(carousel);
    if (state) state.deselectBlock();
  });
  document.addEventListener('shopify:section:select', applyLanguage);
  window.matchMedia('(min-width: 1201px)').addEventListener('change', (event) => { if (event.matches) closeMenu(); });
  const initialise = () => { applyLanguage(); initialiseMotion(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true }); else initialise();
})();


